import { render, staticRenderFns } from "./Scene3.vue?vue&type=template&id=5165a377&scoped=true"
import script from "./Scene3.vue?vue&type=script&lang=js"
export * from "./Scene3.vue?vue&type=script&lang=js"
import style0 from "./Scene3.vue?vue&type=style&index=0&id=5165a377&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5165a377",
  null
  
)

export default component.exports